<div class="main-wrapper">
    <button (click)="change(false)">
        <ion-icon name="remove-outline"></ion-icon>
    </button>
    <input [(ngModel)]="value" (change)="publish()">
    <button (click)="change(true)">
        <ion-icon name="add-outline"></ion-icon>
    </button>
</div>